import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Invoice } from 'dashboard/models/invoice';
import { setInvoices } from 'dashboard/redux/actions/invoices';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadInvoicesList() {
  return async (dispatch: Dispatch) => {
    const invoicesResponse = await SessionClientDashboard.listResource<Invoice, PaginationParams>(
      ApiEndpoint.Invoice,
    );

    const invoices = invoicesResponse.data;

    dispatch(setInvoices(invoices));
  };
}
